// Module
var code = "You should now try to find a clock in a public place and go there..<br> Press ‘I’m there’ when you are.";
// Exports
module.exports = code;